<template>
  <FormulaireRole :id="Number(id)" :key="id" />
</template>

<script>
import FormulaireRole from '@/components/roles/FormulaireRole.vue'

export default {
  name: 'EditTypeUser',
  components: { FormulaireRole },
  props: { id: { type: [String, Number], required: true } },
}
</script>
